import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {API} from "../../app/services/api.service";

/*
 Generated class for the Static page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  selector: 'page-static',
  templateUrl: 'static.html'
})
export class StaticPage {
  public title;
  public body;
  public isLoading = false;
  constructor(public api: API, public navCtrl: NavController, public navParams: NavParams) {
    const page = navParams.get("page");
    this.isLoading = true;
    api.getStaticPage(page).subscribe((payload:any) => {
        this.isLoading = false;
        if (payload.id == 27){
          this.title = "Seite nicht erreichbar";
          this.body = "Diese Seite ist im Moment nicht erreichbar, bitte versuche es später noch einmal.";
        } else {
          this.title = payload.title;
          this.body = payload.body;
        }
      },
      error => this.handleError(error));
  }

  handleError(err) {
    this.title = "Seite nicht erreichbar";
    this.body = "Diese Seite ist im Moment nicht erreichbar, bitte versuche es später noch einmal.";
    console.log(err);
    this.isLoading = false;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad StaticPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/static/static.ts